import React from 'react';

type PageWrapProps = {
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
};

const PageWrap = ({ children, className = '', style }: PageWrapProps) => (
	<div className={`[body.download-banner-dismissed_&]:pt-[5rem] pt-[9rem] ${className}`.trim()} style={style}>
		{children}
	</div>
);

export default PageWrap;
